<template>
  <div style="width: 100%">
    <sui-form v-if="newsItem">
      <sui-form-field class="required" v-bind:class="fieldClass('htmlContent')">
        <label>Content</label>
        <vue-editor v-model="html" @focus="handleFocus('textEditor')" @blur="handleBlur('textEditor')" />
        <br />
        <label>Raw HTML:</label>
        <textarea placeholder="HTML" v-validate="'required'" name="htmlContent" type="text"
          @focus="handleFocus('htmlEditor')" @blur="handleBlur('htmlEditor')" v-model="newsItem.htmlContent" />
      </sui-form-field>
      <sui-form-field v-bind:class="fieldClass('imageUrl')">
        <label>Image link</label>
        <input name="imageUrl" v-model="newsItem.imageUrl" />
        <a v-if="newsItem.imageUrl" v-bind:href="newsItem.imageUrl" target="_blank">
          <img v-if="newsItem.imageUrl" v-bind:src="newsItem.imageUrl" style="max-width: 100px; max-height: 100px;" />
        </a>
      </sui-form-field>
      <sui-button type="button" positive icon="plus" v-on:click="submit">
        Save
      </sui-button>
    </sui-form>
  </div>
</template>

<script>
export default {
  name: 'NewsForm',
  props: ['newsItem', 'error'],
  data() {
    return {
      focusedInput: null,
    };
  },
  computed: {
    html: {
      get() {
        return this.newsItem.htmlContent;
      },
      set(value) {
        if (this.focusedInput === 'textEditor') {
          this.newsItem.htmlContent = value;
        }
      },
    },
  },
  methods: {
    handleFocus(inputName) {
      this.focusedInput = inputName;
    },
    handleBlur(inputName) {
      if (this.focusedInput === inputName) {
        this.focusedInput = null;
      }
    },
    reset() {
      this.$validator.reset();
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
  },
  created() { },
};
</script>



// WEBPACK FOOTER //
// src/components/website/news/NewsForm.vue